import { gql } from '@apollo/client'

export const RSV_LEGAL_AREA_QUERY = gql`
  query rsvLegalAreas(
    $sortBy: RsvLegalAreaSort
    $filter: RsvLegalAreaFilter
    $page: Int
    $limit: Int
  ) {
    rsvLegalAreas(sortBy: $sortBy, filter: $filter, page: $page, limit: $limit) {
      collection {
        id
        title
        archived
        aragContext
      }
      metadata {
        totalCount
      }
    }
  }
`
